/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Editor Tweaks",
  "description": "Implements various tweaks to the PenguinMod Editor for better a experience.",
  "credits": [
    {
      "name": "SharkPool",
      "link": "https://github.com/SharkPool-SP/"
    }
  ],
  "info": [],
  "settings": [
    {
      "dynamic": true,
      "name": "Enable 'checkboxes' in Boolean inputs",
      "id": "checkboxesEnabled",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": true,
      "name": "Toggle scrolling animation in the Toolbox",
      "id": "toolboxScrolling",
      "type": "boolean",
      "default": true
    },
    {
      "dynamic": false,
      "name": "Toggle Block Glow & Shadows in the Editor",
      "id": "blocksGlow",
      "type": "boolean",
      "default": true
    },
    {
      "id": "expandableButtonSize",
      "name": "Expandable Button Size (0-500%)",
      "type": "integer",
      "dynamic": true,
      "min": 0,
      "default": 100,
      "max": 500
    },
  ],
  "userscripts": [
    { "url": "userscript.js" }
  ],
  "tags": [
    "editor",
    "new"
  ],
  "enabledByDefault": false,
  "dynamicEnable": true,
  "dynamicDisable": true
};
export default manifest;